import { render, staticRenderFns } from "./goodsRevenue.vue?vue&type=template&id=aeb9edea&scoped=true&"
import script from "./goodsRevenue.vue?vue&type=script&lang=js&"
export * from "./goodsRevenue.vue?vue&type=script&lang=js&"
import style0 from "./goodsRevenue.vue?vue&type=style&index=0&id=aeb9edea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb9edea",
  null
  
)

export default component.exports